<div class="shadow p-1">
	<div class="row py-1">
		<div class="col-md-2">
			<div>File Type</div>
			<!--<select [(ngModel)]="fileType" class="form-control d-flex align-items-end" (change)="changeFileType()" >-->
			<select
				[(ngModel)]="fileType"
				class="form-control d-flex align-items-end"
				(change)="changeFileType()" data-testid="file-import-file-type">
				<option value="">** Select File Type **</option>
				<option *ngFor="let ft of fileTypes" [ngValue]="ft">
					{{ ft.name }}
				</option>
			</select>
			<div class="text-center" *ngIf="fileReady">
				<div class="mt-2">Uploaded Document</div>
				<div class="overflow-ellipsis font-weight-bold">
					{{ documentUploader.queue[0]?.file?.name | slice : 0 : 100 }}
				</div>
				<div class="mt-2">Document Size</div>
				<div class="overflow-ellipsis font-weight-bold">
					{{
						documentUploader.queue[0]?.file?.size / 1024 / 1024 | number : '.2'
					}}
					MB
				</div>
			</div>
		</div>
		<div class="col-md-10" *ngIf="fileType && !fileReady">
			<div
				ng2FileDrop
				*ngIf="!isSavingNewDoc"
				[ngClass]="fileDragged ? 'nv-file-over' : ''"
				[uploader]="documentUploader"
				class="my-drop-zone col-11 m-0 p-0 h-100"
				(dragover)="onDragover()"
				(dragleave)="onDragout()"
				(mouseleave)="onDragout()"
				(drop)="uploadDocumentFile()">
				<label
					for="file-upload"
					role="button"
					aria-label="Upload"
					class="custom-file-upload py-0 m-0 w-100 h-100 d-flex align-items-center justify-content-center">
					<i class="fa fa-cloud-upload" role="button" aria-label="Upload"></i> Upload
				</label>
				<input
					id="file-upload"
					type="file"
					ng2FileSelect
					[uploader]="documentUploader"
					(change)="uploadDocumentFile()" data-testid="file-import-upload-file"/>
			</div>
		</div>
		<div
			class="col-md-1 text-center d-flex align-items-center"
			*ngIf="fileReady">
			<div>
				<button class="btn btn-primary my-2" (click)="finishUpload()" data-testid="file-import-upload">
					<i class="fa fa-upload mr-2" aria-hidden="true"></i> Upload
				</button>
				<button class="btn btn-secondary my-2" (click)="resetUpload()" data-testid="file-import-cancel">
					Cancel
				</button>
			</div>
		</div>
		<div class="col-md-9" *ngIf="fileReady">
			<!-- Display text content for TXT files -->
			<div *ngIf="isTxtFile">
				<div class="font-weight-bold">File Preview:</div>
				<div class="text-preview-container p-3 border" style="max-height: 400px; overflow-y: auto; white-space: pre-wrap; font-family: monospace; background-color: #f8f9fa;">
					{{ rawTextContent }}
				</div>
			</div>
			<!-- Display table for CSV/XLSX files -->
			<div *ngIf="!isTxtFile && previewRows">
				<div class="font-weight-bold">File Preview:</div>
				<ngx-datatable
					class="material striped"
					[rows]="previewRows"
					[headerHeight]="50"
					[footerHeight]="40"
					[scrollbarH]="true"
					[rowHeight]="35"
					[scrollbarV]="true"
					[ngClass]="previewRows.length > 3 ? 'max-height' : ''">
					<ngx-datatable-column
						*ngFor="let column of previewColumns"
						name="{{ column.name }}"
						prop="{{ column.prop }}"
						[width]="100">
					</ngx-datatable-column>
				</ngx-datatable>
			</div>
		</div>
	</div>
</div>
<div class="col-md-12 my-2">
	<button
		type="button"
		class="btn btn-primary btn-sm"
		(click)="parseFile('third-party-queue')"
		*ngIf="!isParsing" data-testid="file-import-parse-files-third-party">
		Parse Files: third-party-queue
	</button>
	<button
		type="button"
		class="btn btn-primary btn-sm"
		(click)="parseFile('winfactor-queue')"
		*ngIf="!isParsing" data-testid="file-import-parse-files-winfactor-queue">
		Parse Files: winfactor-queue
	</button>
	<div class="text-primary" role="status" *ngIf="isParsing">
		<i class="fa-solid fa-dog fa-beat fa-3x"></i>
	</div>
</div>
<br />
<div class="row" *ngIf="!isParsing">
	<div class="col-2 border">
		<div class="border-0">
			<b>Invoice Date</b><br />{{
				summaryInfo.MaxInvoiceDate | date : 'mediumDate'
			}}<br /><br />
		</div>
		<div class="border-0">
			<b>Invoice Count</b><br />{{ summaryInfo.ImportedInvoiceCount
			}}<br /><br />
		</div>
		<div class="border-0" style="white-space: pre">
			<b>Invoice Data</b><br />{{ summaryInfo.InvoiceSampleData }}<br /><br />
		</div>
	</div>
	<div class="col-2 border">
		<div class="border-0">
			<b>Payment Date</b><br />{{
				summaryInfo.MaxPaymentDate | date : 'mediumDate'
			}}<br /><br />
		</div>
		<div class="border-0">
			<b>Payment Count</b><br />{{ summaryInfo.ImportedPaymentCount
			}}<br /><br />
		</div>
		<div class="border-0" style="white-space: pre">
			<b>Payment Data</b><br />{{ summaryInfo.PaymentSampleData }}<br /><br />
		</div>
	</div>
	<div class="col-2 border">
		<div class="border-0">
			<b>Debtor Date</b><br />{{
				summaryInfo.MaxDebtorUpdatedDate | date : 'mediumDate'
			}}<br /><br />
		</div>
		<div class="border-0">
			<b>Debtor Count</b><br />{{ summaryInfo.ImportedDebtorCount }}<br /><br />
		</div>
		<div class="border-0" style="white-space: pre">
			<b>Debtor Data</b><br />{{ summaryInfo.DebtorSampleData }}<br /><br />
		</div>
	</div>
	<div class="col-2 border">
		<div class="border-0">
			<b>Client Date</b><br />{{
				summaryInfo.MaxClientUpdatedDate | date : 'mediumDate'
			}}<br /><br />
		</div>
		<div class="border-0">
			<b>Client Count</b><br />{{ summaryInfo.ImportedClientCount }}<br /><br />
		</div>
		<div class="border-0" style="white-space: pre">
			<b>Client Data</b><br />{{ summaryInfo.ClientSampleData }}<br /><br />
		</div>
	</div>
	<div class="col-2 border">
		<div class="border-0">
			<b>Cash Date</b><br />{{
				summaryInfo.MaxCashUpdatedDate | date : 'mediumDate'
			}}<br /><br />
		</div>
		<div class="border-0">
			<b>Cash Count</b><br />{{ summaryInfo.ImportedCashCount }}<br /><br />
		</div>
		<div class="border-0" style="white-space: pre">
			<b>Cash Data</b><br />{{ summaryInfo.CashSampleData }}<br /><br />
		</div>
	</div>
	<div class="col-2 border">
		<div>
			<b>Purchase Date</b><br />{{
				summaryInfo.MaxPurchaseDate | date : 'mediumDate'
			}}<br /><br />
		</div>
		<div>
			<b>Purchase Count</b><br />{{ summaryInfo.ImportedPurchaseCount
			}}<br /><br />
		</div>
		<div style="white-space: pre">
			<b>Purchase Data</b><br />{{ summaryInfo.PurchaseSampleData }}<br /><br />
		</div>
	</div>
</div>



// WEBPACK FOOTER //
// ./src/app/developer/file-import/file-import.component.html